<template>
    <div class="conList view">
        <div class="item"><p>{{$t("trade.products.tradeProduct")}}</p><p>{{$t("trade.products.newP")}}</p><p>{{$t("trade.products.rate")}}</p></div>
        <ul v-if="tickList&&tickList.length>0">
            <li :class="isNewP(data)" v-for="(data,index) in tickList" @click="goQuoteChart(data.uiCodeID,index)">
                <span>{{data.symbol}}</span>
                <span>{{data.newP}}</span>
                <span v-if="isOks(data.rate)" :class="isOks(data.rate)"><em>+</em>{{Number(data.rate).toFixed(2)}}%</span>
            </li>
        </ul>
        <InternetSpeed v-else></InternetSpeed>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import InternetSpeed from '@/view/module/InternetSpeed.vue'
    export default {
        name: "QuoteView",
        components:{InternetSpeed},
        props:["tickList"],
        methods:{
            goQuoteChart(id,index){
                this.$bus.$emit('loading', false);
                this.$router.push({path: '/home/quoteChart',query: {id: id,index:index}});
            },
            isNewP: function (obj) {
                let val;
                if (obj.preData) {
                    if (Number(obj.newP) > Number(obj.preData.newP)) {
                        val = "rise"
                    } else if (Number(obj.newP) < Number(obj.preData.newP)) {
                        val = "fall"
                    } else {
                        val = ""
                    }
                } else {
                    if (Number(obj.newP) > Number(obj.preclose)) {
                        val = "rise"
                    } else if (Number(obj.newP) < Number(obj.preclose)) {
                        val = "fall"
                    } else {
                        val = ""
                    }
                }
                return val;
            },
            isOks: function (obj) {
                let val;
                if (obj > 0) {
                    val = "rise"
                } else if (obj == 0) {
                    val = "level"
                } else {
                    val = "fall"
                }
                return val;
            },
        }
    }
</script>
